/**
 * Lunere AJAX add-to-cart — adds items via /cart/add.js and opens the cart drawer.
 * Preserves selling_plan (subscriptions) and other form fields on PDP submit.
 */
(function () {
  if (window.__lunereAtcInitialized) return;
  window.__lunereAtcInitialized = true;

  var CART_UPDATE = 'cart:update';

  function getCartAddUrl() {
    return (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';
  }

  function getSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset.sectionId) ids.push(el.dataset.sectionId);
    });
    return ids;
  }

  function appendSections(formData) {
    var sectionIds = getSectionIds();
    if (!sectionIds.length) return;
    formData.append('sections', sectionIds.join(','));
    formData.append('sections_url', window.location.pathname);
  }

  function dispatchCartUpdate(resource, sourceId, data) {
    document.dispatchEvent(
      new CustomEvent(CART_UPDATE, {
        bubbles: true,
        detail: {
          resource: resource || {},
          sourceId: String(sourceId || ''),
          data: data || {},
        },
      })
    );
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return;
    if (typeof drawer.open === 'function') {
      drawer.open();
    } else if (typeof drawer.showDialog === 'function') {
      drawer.showDialog();
    }
  }

  /**
   * @param {FormData} formData
   * @param {HTMLElement} [trigger]
   * @returns {Promise<void>}
   */
  async function addFormDataToCart(formData, trigger) {
    var variantId = formData.get('id');
    if (!variantId) throw new Error('Variant ID is required');

    var qty = Math.max(1, Number(formData.get('quantity')) || 1);
    var sellingPlan = formData.get('selling_plan');

    // Drop empty selling_plan so one-time purchase stays one-time
    if (!sellingPlan) {
      formData.delete('selling_plan');
    }

    appendSections(formData);

    if (trigger && trigger.getAttribute('aria-busy') === 'true') return;
    var controls = Array.from(document.querySelectorAll('[data-lunere-atc], [data-lunere-atc-form] [type="submit"]'));
    var activeControls = controls.filter(function (control) { return !control.disabled; });
    activeControls.forEach(function (control) { control.disabled = true; });
    if (trigger) trigger.setAttribute('aria-busy', 'true');

    try {
      var response = await fetch(getCartAddUrl(), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      });

      var data = await response.json();

      if (data.status) {
        dispatchCartUpdate(data, variantId, {
          didError: true,
          source: 'product-form-component',
          itemCount: qty,
          variantId: String(variantId),
          sections: data.sections,
        });
        throw new Error(data.description || data.message || 'Could not add to cart');
      }

      dispatchCartUpdate(data, variantId, {
        source: 'product-form-component',
        itemCount: qty,
        variantId: String(variantId),
        sections: data.sections,
      });

      openCartDrawer();
    } finally {
      if (trigger) trigger.removeAttribute('aria-busy');
      activeControls.forEach(function (control) { control.disabled = false; });
    }
  }

  /**
   * @param {string|number} variantId
   * @param {number} quantity
   * @param {HTMLElement} [trigger]
   * @param {string|number|null} [sellingPlan]
   * @returns {Promise<void>}
   */
  async function addToCart(variantId, quantity, trigger, sellingPlan) {
    if (!variantId) throw new Error('Variant ID is required');

    var formData = new FormData();
    formData.append('id', String(variantId));
    formData.append('quantity', String(Math.max(1, Number(quantity) || 1)));

    if (sellingPlan) {
      formData.append('selling_plan', String(sellingPlan));
    }

    return addFormDataToCart(formData, trigger);
  }

  function resolveSellingPlan(form) {
    if (!form) return '';
    var selected = form.querySelector('[data-lunere-purchase-options] input[name="lunere_purchase_plan"]:checked');
    if (selected) return selected.dataset.planId || '';
    var input = form.querySelector('[name="selling_plan"]');
    return input && !input.disabled ? input.value : '';
  }

  function purchaseFormData(form) {
    var data = new FormData(form);
    data.delete('lunere_purchase_plan');
    data.delete('selling_plan');
    var plan = resolveSellingPlan(form);
    if (plan) data.set('selling_plan', plan);
    return data;
  }

  function updatePurchase(form) {
    var options = form.querySelector('[data-lunere-purchase-options]');
    var selected = options && options.querySelector('input[name="lunere_purchase_plan"]:checked');
    if (!selected) return;
    var variantId = form.querySelector('[name="id"]').value;
    var quantity = Math.max(1, Number(form.querySelector('[name="quantity"]').value) || 1);
    var price = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency', currency: options.dataset.currency || 'USD'
    }).format(Number(selected.dataset.price) * quantity / 100);
    var cadence = (selected.dataset.planLabel || '').match(/every\s+\d+\s+(?:day|week|month|year)s?/i);
    var isSubscription = Boolean(selected.dataset.planId);
    var label = isSubscription ? options.dataset.subscribeLabel : options.dataset.addLabel;
    label += ' · ' + price + (isSubscription && cadence ? ' ' + cadence[0] : '');
    form.querySelector('[type="submit"]').textContent = label;
    document.querySelectorAll('[data-lunere-atc]').forEach(function (button) {
      if (button.getAttribute('data-variant-id') === variantId && !button.disabled) button.textContent = label;
    });
    var priceDisplay = form.closest('.lunere-pdp').querySelector('[data-lunere-selected-price]');
    if (priceDisplay) priceDisplay.textContent = selected.dataset.priceLabel;
    var note = form.querySelector('[data-lunere-purchase-note]');
    if (note) note.textContent = isSubscription ? options.dataset.subscriptionNote : options.dataset.oneTimeNote;
  }

  function initializePurchases() {
    document.querySelectorAll('[data-lunere-atc-form]').forEach(function (form) {
      if (!form.querySelector('[data-lunere-purchase-options]')) return;
      form.addEventListener('change', function () { updatePurchase(form); });
      form.addEventListener('input', function () { updatePurchase(form); });
      form.querySelectorAll('[data-qty-minus], [data-qty-plus]').forEach(function (control) {
        control.addEventListener('click', function () { updatePurchase(form); });
      });
      updatePurchase(form);
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-lunere-atc]');
    if (!button || button.disabled) return;

    event.preventDefault();

    var variantId = button.getAttribute('data-variant-id');
    var form = document.querySelector('[data-lunere-atc-form]');
    if (form) {
      var selectedVariant = form.querySelector('[name="id"]');
      if (selectedVariant && selectedVariant.value === variantId) {
        if (!form.reportValidity()) return;
        addFormDataToCart(purchaseFormData(form), button).catch(function (error) {
          console.error('[lunere-atc]', error);
          window.alert(error.message || 'Could not add to cart');
        });
        return;
      }
      window.location.assign('/products/beautiful-skin-bundle');
      return;
    }
    var quantity = button.getAttribute('data-quantity') || 1;
    var sellingPlan = button.getAttribute('data-selling-plan') || '';

    addToCart(variantId, quantity, button, sellingPlan).catch(function (error) {
      console.error('[lunere-atc]', error);
      window.alert(error.message || 'Could not add to cart');
    });
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-lunere-atc-form')) return;

    event.preventDefault();

    var idInput = form.querySelector('[name="id"]');
    var variantId = idInput && idInput.value;
    var submitter = event.submitter || form.querySelector('[type="submit"]');

    if (!variantId || (idInput && idInput.disabled)) return;

    var formData = purchaseFormData(form);

    addFormDataToCart(formData, submitter).catch(function (error) {
      console.error('[lunere-atc]', error);
      window.alert(error.message || 'Could not add to cart');
    });
  }, true);

  window.LunereAddToCart = { add: addToCart, addFormData: addFormDataToCart };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializePurchases);
  else initializePurchases();
})();
